import Magic from "./Magic";
export default Magic;
